// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"zt-z","giftOrPromoSelector":"At-z","disabled":"Bt-z","subTitle":"Ct-z","selectShipAddressMessage":"Dt-z","changePayment":"Et-z"};